import React from 'react';
import '../styles/PoliticaDePrivacidade.css'; 
const PoliticaDePrivacidade = () => {
  return (
    <div className="politica-de-privacidade-container">
      <h1 className="politica-de-privacidade-title">Política de Privacidade</h1>
      <p className="politica-de-privacidade-description">
        Na CR Mesquita, respeitamos sua privacidade e estamos comprometidos em proteger suas informações pessoais.
      </p>
      <p className="politica-de-privacidade-intro">
        Esta política explica como coletamos, usamos e protegemos seus dados. Ao utilizar nossos serviços, você concorda com os termos descritos abaixo.
      </p>

      <div className="politica-de-privacidade-section">
        <h2>1. Coleta de Informações</h2>
        <p>
          Coletamos informações pessoais fornecidas por você, como nome, e-mail, telefone e endereço, quando você realiza um cadastro ou entra em contato conosco.
        </p>
      </div>

      <div className="politica-de-privacidade-section">
        <h2>2. Uso das Informações</h2>
        <p>
          Utilizamos suas informações para fornecer nossos serviços, responder às suas solicitações e melhorar sua experiência em nosso site.
        </p>
      </div>

      <div className="politica-de-privacidade-section">
        <h2>3. Compartilhamento de Dados</h2>
        <p>
          Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir obrigações legais ou fornecer nossos serviços.
        </p>
      </div>

      <div className="politica-de-privacidade-section">
        <h2>4. Segurança</h2>
        <p>
          Adotamos medidas de segurança para proteger suas informações contra acessos não autorizados, alterações ou divulgações.
        </p>
      </div>

      <div className="politica-de-privacidade-section">
        <h2>5. Seus Direitos</h2>
        <p>
          Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. Entre em contato conosco para exercer esses direitos.
        </p>
      </div>

      <div className="politica-de-privacidade-footer">
        <p>
          Para mais informações, entre em contato conosco pelo e-mail: <strong>cr.mesquita@terra.com.br</strong>.
        </p>
      </div>
    </div>
  );
};

export default PoliticaDePrivacidade;